// extracted by mini-css-extract-plugin
export default {"buttonYesNo":"popup_buttonYesNo__8By5b"};